import { Injectable, inject } from '@angular/core';
import { VergleichBaseService } from '@comparit/calculator';
import type { VergleichAnzeigeoptionen, VergleichResponseMap } from '@comparit/calculator';
import type { MarkedItem } from '@comparit/shared';
import type { Observable } from 'rxjs';
import { HausratRoutes } from '../app/app.routes.paths';
// Aliased: this app's service keeps the plain name, as ResultsService does.
import {
  LeistungspunkteFilter,
  Sparte,
  VergleichService as VergleichApi,
} from '@comparit/common-api';

/** Hausrat's Vergleich: the shared comparison page over this Sparte's generated endpoints. */
@Injectable({ providedIn: 'root' })
export class VergleichService extends VergleichBaseService {
  private readonly vergleichApi = inject(VergleichApi);

  readonly backUrl = HausratRoutes.rechner;
  /** A marked tariff goes to its Tarifdetails page first; the Antrag follows from there. */
  override readonly antragUrl = HausratRoutes.tarifdetailsLaden;

  readonly fetch$ = (kombinationen: MarkedItem[]): Observable<VergleichResponseMap> =>
    this.vergleichApi.getVergleich({ sparte: Sparte.Hr, ergebnisIdentifier: kombinationen });

  protected readonly generatePdf$ = (
    kombinationen: MarkedItem[],
    anzeigeoptionen: VergleichAnzeigeoptionen
  ): Observable<object> =>
    this.vergleichApi.generateVergleichPdf(
      {
        sparte: Sparte.Hr,
        vergleichPdfRequest: {
          kombinationen,
          anzeigeoptionen: {
            ...anzeigeoptionen,
            // The page offers no controls for these yet; the backend wants them all the same.
            farbigeHinterlegung: false,
            nurNichtErfuellt: false,
            leistungspunkteFilter: LeistungspunkteFilter.Alle,
          },
        },
      },
      undefined,
      undefined,
      { httpHeaderAccept: 'application/octet-stream' }
    );
}
